import { useSelector } from 'react-redux'

import { isMarketplaceSelector, isPrintAssetSelector } from '@/selectors'
import { translate } from '@/utils/translations'

const classNames = [
  'styled-as-link',
  'vst-btn--transparent',
  'u-weight--normal',
  'underline'
].join(' ')

const DATA_TEST_ID = 'Return Policy Modal'

const Trigger = () => {
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)
  const isMarketplace = useSelector(isMarketplaceSelector)
  const isPrintAsset = useSelector(isPrintAssetSelector)
  const buttonText = () => {
    const translationKey = isBulkEnabled
      ? 'modal_link'
      : (isPrintAsset && isMarketplace)
      ? 'learn_more'
      : 'requirements'

    return translate(`return_policy.pdp_tab.${translationKey}`)
  }

  return (
    <button
      className={classNames}
      data-testid={DATA_TEST_ID}
      id='return-policy'
      type='button'
    >
      {buttonText()}
    </button>
  )
}

export default Trigger
